
import { GLOBAL_QUOTATION_SET_STEP, GLOBAL_QUOTATION_SET_STEPER_SELECTED, GLOBAL_QUOTATION_RESET_STATE_GLBALS } from 'Redux/types/globalQuotationTypes';


// ------------------------------------ ------------------------------------ ------------------------------------
const setGlobalQuotationStepAction = (newStep) => ({
  type: GLOBAL_QUOTATION_SET_STEP,
  step: newStep,
});

export const setGlobalQuotationStep = (newStep) => (dispatch, getState) => {
  if (getState().globalQuotation.globals.step !== newStep) return dispatch(setGlobalQuotationStepAction(newStep));
  return false;
};


// ------------------------------------ ------------------------------------ ------------------------------------
const setGlobalQuotationSteperSelectedAction = (newSteperSelected) => ({
  type: GLOBAL_QUOTATION_SET_STEPER_SELECTED,
  steperSelected: newSteperSelected,
});

export const setGlobalQuotationSteperSelected = (newSteperSelected) => (dispatch, getState) => {
  if (getState().globalQuotation.globals.steperSelected !== newSteperSelected) return dispatch(setGlobalQuotationSteperSelectedAction(newSteperSelected));
  return false;
};

// ------------------------------------ ------------------------------------ ------------------------------------
const resetGlobalQuotationGlobalsAction = (defaults) => ({
  type: GLOBAL_QUOTATION_RESET_STATE_GLBALS,
  defaults,
});

export const resetGlobalQuotationGlobals = (defaults = {}) => (dispatch) => dispatch(resetGlobalQuotationGlobalsAction(defaults));
